import './Predictions.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Tooltip } from 'react-leaflet';
import { v4 } from 'uuid';
import { PointFeature } from '../../../../__legacy__/modules/annotation/components/features/PointFeature';
import { AnnotationToolType } from '../../../../__legacy__/modules/annotation/submodules/annotationTypes/models/annotationToolType';
import { S_AnnotationStatus } from '../../../annotations/annotationStatus/S_AnnotationStatus';
import { IPointPrediction } from '../../jobPredictions.model';

interface IProps {
  predictedPoints?: IPointPrediction[] | null;
  threshold: number;
  predictionClassIds: string[];
}

export const PredictedPoints = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { predictedPoints, predictionClassIds, threshold } = props;
  const renderKey = v4();

  if (!predictedPoints) {
    return <></>;
  }

  return (
    <>
      {predictedPoints.map((predictedClass) => {
        if (!predictionClassIds.includes(predictedClass.classId)) {
          return null;
        }

        return predictedClass.points.map(
          (point, key) =>
            point.score >= threshold &&
            predictedClass.color && (
              <PointFeature
                isActive={false}
                center={{ lat: point.y, lng: point.x }}
                radius={10}
                key={`${predictedClass.className}-${renderKey}-${key}`}
                storeKey={`${predictedClass.className}-${renderKey}-${key}`}
                dashArray={'3 6'}
                color={predictedClass.color}
                type={AnnotationToolType.POINT}
                canRotate={false}
                opacity={1}
                fillOpacity={0}
                tooltip={
                  <Tooltip
                    className='point-tooltip'
                    opacity={1}
                    pane='popupPane'
                  >
                    <div className='point-container'>
                      <span className='point-value'>
                        {t('class')}: <S_AnnotationStatus text={predictedClass.className} />
                      </span>
                    </div>
                    <div className='point-container'>
                      <span className='point-value'>
                        {t('score')}: <S_AnnotationStatus text={point.score.toFixed(2)} />
                      </span>
                    </div>
                    <div className='point-container'>
                      <span className='point-value'>
                        {'X'}: <S_AnnotationStatus text={point.x.toString()} />
                      </span>
                    </div>
                    <div className='point-container'>
                      <span className='point-value'>
                        {'Y'}: <S_AnnotationStatus text={point.y.toString()} />
                      </span>
                    </div>
                  </Tooltip>
                }
              />
            )
        );
      })}
    </>
  );
});
